import React from "react";
import styled from "styled-components";
import { fonts, colors, mediaQueries } from "../shared/config";
import bgDict from '../assets/dictionary_mockup_final.png';
import justBook from '../assets/just_book.png'

const Container = styled.div`
  background: linear-gradient(180deg, #B64040 0%, #AD3131 100%);
  /* min-height: 80vh; */
  color: black;
  padding-left: 5vw;
  display: grid;
  grid-template-columns: 1fr 2fr;
  justify-content: center;
  padding-bottom: 5vw;
  padding-top: 5vw;
  ${mediaQueries.mobile} {
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 10px;
  }
  ${mediaQueries.tablet} {
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 10px;
  }
  column-gap: 84px;
`;



const Text = styled.div`
  font-family: Cardo;
  font-style: normal;
  font-weight: normal;
  margin-top: 30px;
  font-size: 18px;

  ${mediaQueries.mobile} {
    padding: 0 20px;
    margin-top: 5px;
  }
  ${mediaQueries.tablet} {
    padding: 0 20px;
    margin-top: 5px;
  }
`;

const ImageContainer = styled.div`
  padding: auto;
  width: 100%;
  align-items: center;
  justify-content: center;
  ${mediaQueries.mobile} {

  }
`;

const Image = styled.img`
  width: 90%;
  margin: auto;
  margin-top: 42px;
  ${mediaQueries.mobile} {
    width: 100% !important;
    align-items: center !important;
    margin-top: 0;
  }
  ${mediaQueries.tablet} {
    width: 100% !important;
    align-items: center !important;
    margin-top: 0;
  }
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
  padding-right: 10px;
  ${mediaQueries.mobile} {
    text-align: right;
  }
  ${mediaQueries.tablet} {
    text-align: right;
  }
`;

const Title = styled.div`
  font-size: 96px;
  line-height: 90%;
  font-family: Staatliches;
  margin-top: 40px;
  color: white;
  ${mediaQueries.mobile} {
    margin-top: 40px;
    margin-left: 20px;
    font-size: 36px;
  }
  ${mediaQueries.tablet} {
    margin-top: 40px;
    margin-left: 20px;
    font-size: 40px;
  }
`;

const Subheading = styled.div`
  font-size: 48px;
  line-height: 90%;
  font-family: Staatliches;
  ${mediaQueries.mobile} {
    /* margin-top: 40px; */
    margin-left: 20px;
    font-size: 24px;
  }
  ${mediaQueries.tablet} {
    /* margin-top: 40px; */
    margin-left: 20px;
    font-size: 30px;
  }
`;

export default function NewCloseQuarters(props) {
  return(

     
      <Container>
        <div>
        {props.data.map(block=>{
          if(block.type==="header"){
              return(<Title>{block.content}</Title>);
          }
          if(block.type==="subheader"){
            return(<Subheading>{block.content}</Subheading>);
        }

          })} 

        </div>
        <ImageContainer>
            <Image src={bgDict} alt="dictionary"></Image>
            {/* <Credits> {block.image_credits} </Credits> */}
            {/* <Image src={justBook} alt="dictionary"></Image> */}

        </ImageContainer>
        
       

      </Container>

  )};